import { HomeWrap } from "./HomeWrap";
import { HomeLink } from "./HomeLink";
import mascot from "@/assets/mascot-normal-64.png";
import { APP_STORE_URL } from "./HomeCTAButtons";
import { MadeByRemoteWorkers } from "@/components/MadeByRemoteWorkers";


const link = "text-[#BFA88E] no-underline transition-colors hover:text-[#F6EFE4]";
const head = "mb-3 text-xs font-bold uppercase tracking-[.14em] text-[#7C6650]";

export function HomeFooter() {
  return (
    <footer className="bg-[#2A1D12] pb-10 pt-[52px] text-[15px] text-[#BFA88E]">
      <HomeWrap>
        <div className="grid gap-8 min-[820px]:grid-cols-[1.4fr_.8fr_.8fr]">
          <div>
            <div className="flex items-center gap-2">
              <img src={mascot} alt="" aria-hidden="true" className="h-8 w-8 object-contain" />
              <span className="font-display text-2xl font-semibold tracking-[-0.02em] text-[#F6EFE4]">
                grounded
              </span>
            </div>
            <p className="mt-3 max-w-[38ch] leading-[1.55]">
              Café research for people who need the WiFi to hold up. Built in Los Angeles.
            </p>
          </div>

          <div>
            <h3 className={head}>App</h3>
            <ul className="m-0 list-none p-0">
              <li className="py-[5px]">
                <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className={link}>
                  Download for iPhone
                </a>
              </li>
              <li className="py-[5px]">
                <HomeLink to="/browse" className={link}>
                  Browse cafés
                </HomeLink>
              </li>
              <li className="py-[5px]">
                <HomeLink to="/support" className={link}>
                  Support
                </HomeLink>
              </li>
            </ul>
          </div>

          <div>
            <h3 className={head}>More</h3>
            <ul className="m-0 list-none p-0">
              <li className="py-[5px]">
                <HomeLink to="/owner-login" className={link}>
                  Café owner login
                </HomeLink>
              </li>
              <li className="py-[5px]">
                <HomeLink to="/privacy" className={link}>
                  Privacy
                </HomeLink>
              </li>
              <li className="py-[5px]">
                <HomeLink to="/terms" className={link}>
                  Terms
                </HomeLink>
              </li>
              <li className="py-[5px]">
                <a
                  href="https://instagram.com/groundedtheapp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={link}
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-[rgba(246,239,228,.12)] pt-[22px]">
          <p className="text-[13.5px] text-[#7C6650]">
            © 2026 Grounded App LLC, groundedtheapp.com
          </p>
          <MadeByRemoteWorkers className="mt-2" />
        </div>

      </HomeWrap>
    </footer>
  );
}
